<template>
    <div class="search-page" ref="currentOffer">
        <div class="page">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Oferta curentă</h1>
                    <p>Vezi produsele selectate pentru ofertare</p>

                    <OfferEditor :in-create-mode="true" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OfferEditor from "../../components/offer/OfferEditor";

    export default {
        name: 'CurrentOffer',
        components: {OfferEditor},
    }
</script>

<style scoped>
    .search-page {
        flex-grow: 1;
        display: flex;
    }

    .page {
        flex-grow: 1;
        position: relative;
    }

    .cover {
        width: 100%;
        height: 264px;
        position: relative;
        background: #024A8C;
    }

    .container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 60px;
        color: white;
        width: 100%;
    }

    .white-page {
        background: white;
        border-radius: 5px;
        color: black;
        padding: 25px 20px;

        margin-top: 50px;
        margin-bottom: 20px;

        -webkit-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        -moz-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
    }

    .white-page h1 {
        color: #024A8C;
        font-weight: 600;
    }

    .white-page h2, h3, h4, h5, h6 {
        color: #6F6F6F;
        margin-top: 10px;
    }
</style>
